import { useState, useEffect, useCallback } from "react";
import { RefreshCw, CheckCircle, Search, ChevronLeft, ChevronRight } from "lucide-react";
import api from "../../services/api";
import DoletasStatsCards from "./DoletasStatsCards";
import DoletasPendingTable from "./DoletasPendingTable";

export default function DoletasApproval() {
  var _pending = useState([]);
  var pending = _pending[0];
  var setPending = _pending[1];
  var _total = useState(0);
  var total = _total[0];
  var setTotal = _total[1];
  var _page = useState(1);
  var page = _page[0];
  var setPage = _page[1];
  var _loading = useState(true);
  var loading = _loading[0];
  var setLoading = _loading[1];
  var _roleF = useState("");
  var roleF = _roleF[0];
  var setRoleF = _roleF[1];
  var _sourceF = useState("");
  var sourceF = _sourceF[0];
  var setSourceF = _sourceF[1];
  var _search = useState("");
  var searchV = _search[0];
  var setSearchV = _search[1];
  var _stats = useState(null);
  var stats = _stats[0];
  var setStats = _stats[1];

  var fetchPending = useCallback(async function () {
    setLoading(true);
    try {
      var params = new URLSearchParams();
      params.append("page", page);
      params.append("limit", "20");
      if (roleF) params.append("user_role", roleF);
      if (sourceF) params.append("source", sourceF);
      if (searchV) params.append("search", searchV);
      var res = await api.get("/doletas/pending?" + params.toString());
      setPending(res.data.transactions || []);
      setTotal(res.data.total || 0);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [page, roleF, sourceF, searchV]);

  var fetchStats = useCallback(async function () {
    try {
      var res = await api.get("/doletas/stats");
      setStats(res.data);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(function () { fetchPending(); }, [fetchPending]);
  useEffect(function () { fetchStats(); }, [fetchStats]);

  function refreshAll() { fetchPending(); fetchStats(); }

  async function handleApproveAll() {
    if (!window.confirm("Aprovar TODAS as " + total + " transacoes pendentes?")) return;
    try {
      var res = await api.post("/doletas/approve-all");
      alert(res.data.message);
      refreshAll();
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    }
  }

  async function handleCalculate() {
    if (!window.confirm("Calcular doletas para todos os produtos?")) return;
    try {
      setLoading(true);
      var res = await api.post("/doletas/calculate");
      alert(res.data.message);
      refreshAll();
    } catch (err) {
      alert("Erro: " + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  }

  var totalPages = Math.ceil(total / 20);

  return (
    <div className="space-y-6" data-testid="doletas-approval-panel">
      <DoletasStatsCards stats={stats} />

      <div className="bg-white rounded-xl border border-gray-200 p-4">
        <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
          <div className="flex flex-wrap gap-2">
            <button onClick={handleCalculate} className="flex items-center gap-2 px-4 py-2 bg-[#3B82F6] text-white rounded-lg text-sm font-medium hover:bg-blue-600 transition-colors" data-testid="btn-calculate-doletas">
              <RefreshCw className="w-4 h-4" />Calcular Doletas
            </button>
            {total > 0 && (
              <button onClick={handleApproveAll} className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-white rounded-lg text-sm font-medium hover:bg-emerald-600 transition-colors" data-testid="btn-approve-all">
                <CheckCircle className="w-4 h-4" />Aprovar Todas ({total})
              </button>
            )}
          </div>
          <div className="flex flex-wrap gap-2 w-full sm:w-auto">
            <div className="relative flex-1 sm:flex-none">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input type="text" placeholder="Buscar..." value={searchV}
                onChange={function (e) { setSearchV(e.target.value); setPage(1); }}
                className="pl-9 pr-3 py-2 border border-gray-200 rounded-lg text-sm w-full sm:w-48"
                data-testid="search-pending" />
            </div>
            <select value={roleF} onChange={function (e) { setRoleF(e.target.value); setPage(1); }}
              className="px-3 py-2 border border-gray-200 rounded-lg text-sm" data-testid="filter-role">
              <option value="">Todos</option>
              <option value="client">Clientes</option>
              <option value="broker">Vendedores</option>
            </select>
            <select value={sourceF} onChange={function (e) { setSourceF(e.target.value); setPage(1); }}
              className="px-3 py-2 border border-gray-200 rounded-lg text-sm" data-testid="filter-source">
              <option value="">Todas Fontes</option>
              <option value="consorcio">Consorcio</option>
              <option value="carta_contemplada">Carta Contemplada</option>
              <option value="seguro_auto">Seguro Auto</option>
              <option value="seguro_vida">Seguro Vida</option>
              <option value="seguro_residencial">Seguro Residencial</option>
              <option value="plano_saude">Plano Saude</option>
            </select>
          </div>
        </div>
      </div>

      <DoletasPendingTable pending={pending} total={total} loading={loading} onRefresh={refreshAll} />

      {totalPages > 1 && (
        <div className="bg-white rounded-xl border border-gray-200 px-4 py-3 flex items-center justify-between">
          <span className="text-xs text-gray-500">Pagina {page} de {totalPages}</span>
          <div className="flex gap-1">
            <button disabled={page <= 1} onClick={function () { setPage(page - 1); }} className="p-1.5 rounded-lg hover:bg-gray-100 disabled:opacity-30"><ChevronLeft className="w-4 h-4" /></button>
            <button disabled={page >= totalPages} onClick={function () { setPage(page + 1); }} className="p-1.5 rounded-lg hover:bg-gray-100 disabled:opacity-30"><ChevronRight className="w-4 h-4" /></button>
          </div>
        </div>
      )}
    </div>
  );
}
